var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_7040)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 12.5,
    fill: "#E7E0F1"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 9,
    cy: 10,
    r: 7,
    fill: "#E7E0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.94 23.1999C16.36 23.1999 16.715 23.0549 17.005 22.7649C17.295 22.4749 17.44 22.1199 17.44 21.6999C17.44 21.2799 17.295 20.9249 17.005 20.6349C16.715 20.3449 16.36 20.1999 15.94 20.1999C15.52 20.1999 15.165 20.3449 14.875 20.6349C14.585 20.9249 14.44 21.2799 14.44 21.6999C14.44 22.1199 14.585 22.4749 14.875 22.7649C15.165 23.0549 15.52 23.1999 15.94 23.1999ZM14.86 18.5799H17.08C17.08 17.9199 17.155 17.3999 17.305 17.0199C17.455 16.6399 17.88 16.1199 18.58 15.4599C19.1 14.9399 19.51 14.4449 19.81 13.9749C20.11 13.5049 20.26 12.9399 20.26 12.2799C20.26 11.1599 19.85 10.2999 19.03 9.69988C18.21 9.09988 17.24 8.79988 16.12 8.79988C14.98 8.79988 14.055 9.09988 13.345 9.69988C12.635 10.2999 12.14 11.0199 11.86 11.8599L13.84 12.6399C13.94 12.2799 14.165 11.8899 14.515 11.4699C14.865 11.0499 15.4 10.8399 16.12 10.8399C16.76 10.8399 17.24 11.0149 17.56 11.3649C17.88 11.7149 18.04 12.0999 18.04 12.5199C18.04 12.9199 17.92 13.2949 17.68 13.6449C17.44 13.9949 17.14 14.3199 16.78 14.6199C15.9 15.3999 15.36 15.9899 15.16 16.3899C14.96 16.7899 14.86 17.5199 14.86 18.5799ZM16 27.9999C14.34 27.9999 12.78 27.6849 11.32 27.0549C9.86 26.4249 8.59 25.5699 7.51 24.4899C6.43 23.4099 5.575 22.1399 4.945 20.6799C4.315 19.2199 4 17.6599 4 15.9999C4 14.3399 4.315 12.7799 4.945 11.3199C5.575 9.85988 6.43 8.58988 7.51 7.50988C8.59 6.42988 9.86 5.57488 11.32 4.94488C12.78 4.31488 14.34 3.99988 16 3.99988C17.66 3.99988 19.22 4.31488 20.68 4.94488C22.14 5.57488 23.41 6.42988 24.49 7.50988C25.57 8.58988 26.425 9.85988 27.055 11.3199C27.685 12.7799 28 14.3399 28 15.9999C28 17.6599 27.685 19.2199 27.055 20.6799C26.425 22.1399 25.57 23.4099 24.49 24.4899C23.41 25.5699 22.14 26.4249 20.68 27.0549C19.22 27.6849 17.66 27.9999 16 27.9999ZM16 25.5999C18.68 25.5999 20.95 24.6699 22.81 22.8099C24.67 20.9499 25.6 18.6799 25.6 15.9999C25.6 13.3199 24.67 11.0499 22.81 9.18988C20.95 7.32988 18.68 6.39988 16 6.39988C13.32 6.39988 11.05 7.32988 9.19 9.18988C7.33 11.0499 6.4 13.3199 6.4 15.9999C6.4 18.6799 7.33 20.9499 9.19 22.8099C11.05 24.6699 13.32 25.5999 16 25.5999Z",
    fill: "#873CAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_7040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support_icon.f838fbeb91f52767ed565503cbfaa353.svg";
export { ForwardRef as ReactComponent };